import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import WhatsAppTemplatesManageGql from '@/extensions/communication/store/graphql/queries/WhatsAppTemplatesManage.gql';
import CreateWhatsAppTemplateGql from '@/extensions/communication/store/graphql/mutations/CreateWhatsAppTemplate.gql';
import EditWhatsAppTemplateGql from '@/extensions/communication/store/graphql/mutations/EditWhatsAppTemplate.gql';
import DeleteWhatsAppTemplateGql from '@/extensions/communication/store/graphql/mutations/DeleteWhatsAppTemplate.gql';

// WhatsApp template management (authoring goes through Meta's review). Account-scoped.
export default {
    fetchAll: accountId =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: WhatsAppTemplatesManageGql, variables: { account_id: parseInt(accountId) }, fetchPolicy: 'network-only' })
                .then(({ data }) => resolve(data.EX_COMM_WhatsAppTemplates || []))
                .catch(err => reject(err));
        }),

    create: (accountId, template) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({ mutation: CreateWhatsAppTemplateGql, variables: { account_id: parseInt(accountId), ...template } })
                .then(({ data }) => resolve(data.EX_COMM_CreateWhatsAppTemplate))
                .catch(err => reject(err));
        }),

    edit: (accountId, templateId, template) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({ mutation: EditWhatsAppTemplateGql, variables: { account_id: parseInt(accountId), template_id: templateId, ...template } })
                .then(({ data }) => resolve(data.EX_COMM_EditWhatsAppTemplate))
                .catch(err => reject(err));
        }),

    remove: (accountId, name) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({ mutation: DeleteWhatsAppTemplateGql, variables: { account_id: parseInt(accountId), name } })
                .then(({ data }) => resolve(data.EX_COMM_DeleteWhatsAppTemplate))
                .catch(err => reject(err));
        }),
};
